import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { optimizeUnsplashUrl } from "@/utils/imageOptimize";

const TESTIMONIALS = [
  {
    image: "https://images.unsplash.com/photo-1764380749932-57ad1cb79a07",
    quote: {
      fr: "Nous avons offert cette chanson à ma mère pour ses 60 ans. Elle a pleuré de joie, c'était juste parfait.",
      en: "We gifted this song to my mother for her 60th birthday. She cried tears of joy, it was just perfect.",
    },
    name: "Camille & Julien",
  },
  {
    image: "https://images.unsplash.com/photo-1581952975975-08cd95a728d4",
    quote: {
      fr: "La demande en mariage la plus originale possible. Notre chanson personnalisée a fait toute la différence.",
      en: "The most original proposal ever. Our personalized song made all the difference.",
    },
    name: "Sarah & Thomas",
  },
  {
    image: "https://images.unsplash.com/photo-1543342384-1f1350e27861",
    quote: {
      fr: "Pour l'arrivée de notre fille, une berceuse rien qu'à elle. Un souvenir que nous garderons toute la vie.",
      en: "For our daughter's arrival, a lullaby just for her. A memory we'll keep forever.",
    },
    name: "Léa & Marc",
  },
];

export default function Testimonials() {
  const { t, language } = useI18n();
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <h2 className="font-heading text-2xl font-medium tracking-tight sm:text-3xl lg:text-4xl">
            {t("landing.testimonialsTitle")}
          </h2>
          <Link to="/avis" className="text-sm font-medium text-primary hover:underline" data-testid="landing-see-all-reviews-link">
            {t("common.seeAll")} →
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((item, i) => (
            <motion.div
              key={item.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="overflow-hidden rounded-2xl border border-border bg-card"
              data-testid={`landing-testimonial-${i + 1}`}
            >
              <div className="h-48 w-full overflow-hidden">
                <img src={optimizeUnsplashUrl(item.image)} alt={item.name} className="h-full w-full object-cover" loading="lazy" width="48" height="48" />
              </div>
              <div className="p-6">
                <Quote className="h-5 w-5 text-primary/50" />
                <p className="mt-3 text-sm leading-relaxed text-foreground/90">{item.quote[language] || item.quote.fr}</p>
                <p className="mt-4 font-heading text-sm font-medium text-muted-foreground">— {item.name}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
